import React from 'react';
import EllipsisAndTooltip from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import { fieldAnomaly } from '../../../../utils/formatter';

// 联动分析
export const linkageAnalysis = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 1,
        render: (text, record, index) => index + 1
    },
    {
        title: '造假路径',
        dataIndex: 'key',
        width: 5,
        render: text => <EllipsisAndTooltip text={text} />
    },
    {
        title: '业务分析',
        dataIndex: 'value',
        width: 10,
        render: text => <EllipsisAndTooltip text={text} />
    }
];

// 造假模块模板
export const fraudTemplateColumn = [
    {
        title: '时间',
        dataIndex: 'abnormalYear',
        width: 50,
        render: fieldAnomaly
    },
    {
        title: '---',
        dataIndex: 'abnormalIndexValue',
        render: fieldAnomaly
    },
    {
        title: '期望值',
        dataIndex: 'wishValue',
        render: fieldAnomaly
    },
    {
        title: '残差',
        dataIndex: 'currentRedual',
        render: fieldAnomaly
    },
    {
        title: '残差正常范围',
        dataIndex: 'abnormalRange',
        render: fieldAnomaly
    }
];

export const rawTemplateColumn = [
    {
        title: '时间',
        dataIndex: 'abnormalYear',
        width: 50,
        render: fieldAnomaly
    },
    {
        title: '---',
        dataIndex: 'abnormalIndexValue',
        render: fieldAnomaly
    },
    {
        title: '异常等级',
        dataIndex: 'cutvalue',
        render: d => {
            let color = '', fraudClass = '';
            let val = parseInt(d, 10);
            if(val < 4) {
                color = 'green-font';
                fraudClass = '(舞弊风险较低)';
            }else if(4 <= val && val < 7) {
                color = 'orange-font';
                fraudClass = '(存在舞弊风险)';
            }else if(7 <= val && val < 10) {
                color = 'red-font'; 
                fraudClass = '(舞弊风险较高)';
            }else {
                color = 'green-font';
                fraudClass = '--';
            }
            return <span className={color}>{val}&nbsp;&nbsp;{fraudClass}</span>;
        }
    },
    {
        title: '上限',
        dataIndex: 'upperBound',
        render: fieldAnomaly
    },
    {
        title: '下限',
        dataIndex: 'lowerBound',
        render: fieldAnomaly
    }
];


// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/columns.jsx